import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { TextField } from '@mui/material';
import { ProductoImagesI } from '../../../models/productos';
import { mediaFilter } from '../../../utils/image';

interface SortableImageItemProps {
  imagen: ProductoImagesI;
  index: number;
  onRemove: (index: number) => void;
  handleInputChange: (index: number, key: 'titulo' | 'descripcion', value: string) => void;
  name: 'productos_imagenes' | 'productos_imagenes_pequenas'
}

const SortableImageItem: React.FC<SortableImageItemProps> = ({
  imagen,
  index,
  onRemove,
  handleInputChange,
  name
}) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
  } = useSortable({ id: imagen.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    cursor: 'grab',
    display: 'flex',
    flexDirection: 'column' as const,
    marginBottom: 20,
    gap: 10,
  };

const preventDragOnInput = (e: React.PointerEvent) => {
  const tag = (e.target as HTMLElement).tagName;
  if (['INPUT', 'TEXTAREA', 'BUTTON'].includes(tag)) {
    e.stopPropagation();
  }
};

  return (
    <div
      ref={setNodeRef}
      style={style}
      {...attributes}
      {...listeners}
    >
      <img
        src={
          imagen.archivoUrl?.startsWith('blob:')
            ? imagen.archivoUrl
            : mediaFilter({ path: imagen.archivoUrl })
        }
        alt={`preview-${index}`}
        className="w-[140px] h-[110px] object-cover mx-auto"
      />
      <p style={{ textAlign: 'center', fontSize: 12 }}>Orden: {imagen.orden}</p>
      
      {name === 'productos_imagenes_pequenas' && (
        <TextField     
        onPointerDown={preventDragOnInput}
          type="text"
          placeholder="Título"
          value={imagen.titulo}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            handleInputChange(index, 'titulo', e.target.value)
          }
        />
      )}
      
      {name === 'productos_imagenes_pequenas' && (
        <TextField
        onPointerDown={preventDragOnInput}
          placeholder="Descripción"
          value={imagen.descripcion}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            handleInputChange(index, 'descripcion', e.target.value)
          }
        />
      )}

      <button type='button' onPointerDown={preventDragOnInput} onClick={() => onRemove(index)}>Eliminar</button>
    </div>
  );
};

export default SortableImageItem;
